/**
 *
 * @module entry
 * @desc {SDK.Services.Exception} entry point.
 *
 */

import ErrorReason from './errorReason';
import ErrorCode from './errorCode';
import ExceptionReference from './exceptionReference';
import InvalidArgumentException from './invalidArgumentException';
import ProviderException from './providerException';
import ServiceException from './serviceException';

/**
 *
 * @typedef SDK.Services.Exception
 * @type {Object}
 *
 * @property {ErrorReason} ErrorReason
 * @property {ErrorCode} ErrorCode
 * @property {ExceptionReference} ExceptionReference
 * @property {InvalidArgumentException} InvalidArgumentException
 * @property {ProviderException} ProviderException
 * @property {ServiceException} ServiceException
 *
 */

/**
 *
 * @type {SDK.Services.Exception}
 *
 */
export default {

    ErrorReason,
    ErrorCode,
    ExceptionReference,
    InvalidArgumentException,
    ProviderException,
    ServiceException

};



// WEBPACK FOOTER //
// ./src/services/exception/entry.js